(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pivot-cart-drawer"] && !Shopify.designMode) return;
  try {
    class PivotCartDrawerSidebar extends HTMLElement {
    connectedCallback() {
      // super();
      this.$suggestions = this.querySelector('pivot-suggestions-drawer');

      this.desktopPosition = this.$suggestions?.getAttribute('desktop-position');
      this.mobilePosition = this.$suggestions?.getAttribute('mobile-position');

      this.setPosition();
      this.addEventListener('resize', this.setPosition);
    }
    setPosition = () => {
      const isMobile = window.innerWidth < 750;
      const position = isMobile ? this.mobilePosition : this.desktopPosition;
      console.log('=== Setting mobile ===', { isMobile, position, mb: this.mobilePosition, dk: this.desktopPosition });
      switch (position) {
        case 'below_line_items':
          this.observer('.cart-drawer__content .cart-drawer__items', 'beforeend');
          break;
        case 'above_footer':
          this.observer('.cart-drawer__content .cart-drawer__summary', 'afterbegin');
          break;
      }
    };
    observer(selector, position) {
      this.$lineItemsWrapper = document.querySelector(selector);
      console.log('Wrapper', this.$lineItemsWrapper);

      const observer = new MutationObserver((mutations) => {
        console.log('=== EDIT ====', this.$lineItemsWrapper);
        mutations.forEach((mutation) => {
          console.log('CAMBIO ===', mutation);
        });
        const child = this.$lineItemsWrapper.querySelector('pivot-suggestions-drawer');
        if (child) return;

        this.$lineItemsWrapper.insertAdjacentHTML(position, this.innerHTML);
      });

      observer.observe(this.$lineItemsWrapper, {
        childList: true,
      });

      console.log('INSERT', position, this.$lineItemsWrapper);
      this.$lineItemsWrapper.insertAdjacentHTML(position, this.innerHTML);
    }
  }
  if (!customElements.get('pivot-cart-drawer-sidebar')) {
    customElements.define('pivot-cart-drawer-sidebar', PivotCartDrawerSidebar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_pivot-cart-drawer__boleta-factura"] && !Shopify.designMode) return;
  try {
    class PivotInvoiceForm extends HTMLElement {
    constructor() {
      super();

      this._state = {
        button: 'save',
        disabledButton: true,
        disabledMainButton: false,
      };

      this.$regionsMapping = JSON.parse(this.querySelector('#pivot-invoice-regions-mapping').textContent);

      this.$rutInput = this.querySelector('input[name="attributes[RUTEmpresa]"]');
      this.$regionSelector = this.querySelector('select[name="attributes[Region]"]');
      this.$communeSelector = this.querySelector('select[name="attributes[Comuna]"]');
      this.$form = this.querySelector('form');
      this.$label = this.querySelector('.cart-discount__label');
      this.$button = this.querySelector('button[type="submit"]');
      this.$clearButton = this.querySelector('#pivot-invoice-clear');
      this.$rutErrorMessage = this.querySelector('.rut-error-message');

      this.initEvents();

      // Verificación inicial del estado del formulario
      this.checkFormState(isInitial);
    }

    onStateChange = () => {
      console.log('Seleccionando el botón apropiado');
      this.$button = this.querySelector('button[type="submit"]');
      this.$clearButton = this.querySelector('#pivot-invoice-clear');
      this.$mainButton = document.querySelector("cart-drawer-component button[type='submit'][name='checkout']");

      this.$button.disabled = this._state.disabledButton;
      this.$clearButton.disabled = this._state.disabledButton;

      this.$mainButton.disabled = this._state.disabledMainButton;

      if (this._state.button === 'save') {
        this.$button.style.display = 'block';
        this.$clearButton.style.display = 'none';
      } else {
        this.$button.style.display = 'none';
        this.$clearButton.style.display = 'block';
      }
    };

    initEvents = () => {
      this.$regionSelector.addEventListener('change', this.handleRegionChange);
      this.$rutInput.addEventListener('keyup', this.handleRutChange);
      this.$rutInput.addEventListener('blur', this.handleRutChange);
      this.$form.addEventListener('submit', this.handleSubmit);
      this.$clearButton.addEventListener('click', this.handleClear);

      this.handleRegionChange();
      this.$communeSelector.value = this.$communeSelector.dataset.value;

      this.$form.addEventListener('change', () => {
        this.checkFormState();
      });
    };

    checkFormState = (isInitial = false) => {
      const $invalid = this.$form.querySelector(':invalid');
      const $inputs = this.$form.querySelectorAll('input, select');
      const allEmpty = Array.from($inputs).every((input) => input.value === '');

      // Cambiar aspecto
      if (allEmpty || !isInitial) {
        this.$clearButton.textContent = 'Guardar';
        this.$clearButton.classList.remove('button-secondary');
      } else {
        this.$clearButton.textContent = 'Limpiar';
        this.$clearButton.classList.add('button-secondary');
      }

      // El botón está habilitado si no hay campos inválidos o si todos están vacíos
      this._state.disabledButton = (!!$invalid && !allEmpty) || isInitial;

      // Si todos los campos están vacíos, el botón debe ser 'limpiar'
      this._state.button = allEmpty ? 'clear' : 'save';

      console.log('Invalid element:', $invalid, 'All empty:', allEmpty);
      this._state.disabledMainButton = !isInitial || !allEmpty || !this._state.disabledButton;
      this.onStateChange();
    };

    handleRegionChange = () => {
      const region = this.$regionSelector.value;
      const communes = this.$regionsMapping[region];
      console.log('Cambio de región', region, communes, this.$communeSelector);
      if (!communes) return;
      this.$communeSelector.innerHTML =
        `<option value="">Selecciona una comuna</option>` +
        communes.map((commune) => `<option value="${commune}">${commune}</option>`).join('');
      // this.$communeSelector.dispatchEvent(new Event('change'));
    };

    handleRutChange = () => {
      console.log('Validando RUT', this.$rutInput.value);
      const $errorMessage = this.querySelector('.rut-error-message');

      if (this.$rutInput.value == '' || validateRut(this.$rutInput.value)) {
        this.$rutInput.setCustomValidity('');
        this.$rutInput.value = formatDNI({ rut: this.$rutInput.value, pais: 'CL' });
        $errorMessage.classList.remove('show');
      } else {
        // this.$rutInput.value = '';
        this.$rutInput.setCustomValidity('Ingresa un RUT válido');
        // Mostrar mensaje de error sin llevar el foco
        $errorMessage.classList.add('show');
      }

      // Actualizar el estado del formulario después de validar el RUT
      this.checkFormState();
    };

    handleSubmit = (e) => {
      e.preventDefault();

      // Verificar si el RUT es válido antes de enviar
      if (this.$rutInput.value && !validateRut(this.$rutInput.value)) {
        this.$rutErrorMessage.classList.add('show');
        return;
      }

      const data = Object.fromEntries(new FormData(e.target));
      console.log('Formulario enviado', data);
      this.$button.disabled = true;
      this.$button.textContent = 'Guardando...';
      this.$clearButton.disabled = true;

      fetch('/cart/update.js', {
        method: 'POST',
        body: new FormData(e.target),
      })
        .then(() => {
          console.log('Carrito actualizado');
          if (data['attributes[RUTEmpresa]'] && data['attributes[RazonSocial]']) {
            this.$label.innerHTML = `<div><span class="pvt-invoicing-label">Factura:</span> ${data['attributes[RazonSocial]']} - ${data['attributes[RUTEmpresa]']}</div>`;
          } else {
            this.$label.textContent = '';
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this._state.button = 'clear';
          this.$button.disabled = false;
          this.$button.textContent = 'Guardar';
          this.$clearButton.disabled = false;
          this._state.disabledMainButton = false;
          this.onStateChange();
        });
    };

    handleClear = () => {
      const attributes = {
        RUTEmpresa: null,
        RazonSocial: null,
        Giro: null,
        DireccionEmpresa: null,
        Region: null,
        Comuna: null,
      };
      // Ocultar mensaje de error al limpiar
      this.$rutErrorMessage.classList.remove('show');
      this.$clearButton.disabled = true;
      this.$clearButton.textContent = 'Limpiando...';
      this.$button.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({ attributes }),
      })
        .then(() => {
          console.log('Carrito actualizado');
          this.querySelectorAll('input,select').forEach((el) => (el.value = ''));
          this.$label.textContent = '¿Necesitas factura?';
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.$button.disabled = false;
          this.$button.textContent = 'Guardar';
          this.$clearButton.disabled = false;
          this.$clearButton.textContent = 'Limpiar';

          this._state = {
            button: 'save',
            disabledButton: true,
            disabledMainButton: false,
          };

          // Actualizar el estado del formulario después de limpiar
          this.onStateChange();
        });
    };
  }

  if (!customElements.get('pivot-invoice-form')) {
    customElements.define('pivot-invoice-form', PivotInvoiceForm);
  }

  const byCountry = {
    cl: function ({ rut }) {
      const regex = /[^\dkK]/g;

      rut = rut.toString().replace(regex, '');
      const dv = rut.slice(-1).toUpperCase();
      if (rut && dv) {
        rut = rut.slice(0, -1) + '-' + dv;
      }
      return rut;
    },
  };

  function formatDNI({ rut, pais, tipo }) {
    return byCountry[pais?.toLowerCase()]?.({ rut, tipo }) || rut;
  }

  function validateRut(rut) {
    rut = rut.replace(/[^0-9kK]/g, ''); // Eliminar todos los caracteres no numéricos excepto la 'k' o 'K'
    if (rut.length < 8 || rut.length > 9) {
      return false;
    } // El RUT debe tener al menos 2 caracteres (cuerpo + dígito verificador)
    console.log(rut);
    let cuerpo = rut.slice(0, -1); // Obtener el cuerpo del RUT (sin el dígito verificador)
    console.log(cuerpo);
    let dv = rut.slice(-1).toUpperCase(); // Obtener el dígito verificador (puede ser 'k' o 'K' en mayúsculas)

    let suma = cuerpo
      .split('')
      .reverse()
      .reduce((acc, digit, index) => acc + parseInt(digit) * ((index % 6) + 2), 0);

    let resultado = 11 - (suma % 11); // Calcular el dígito verificador esperado
    console.log(resultado);
    let digitoVerificador = resultado === 11 ? '0' : resultado === 10 ? 'K' : resultado.toString();
    console.log(digitoVerificador);
    return dv == digitoVerificador;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pivot-product-sku"] && !Shopify.designMode) return;
  try {
    class PivotProductSku extends HTMLElement {
    constructor() {
      super();
      this.currentUrl = window.location.href;

      // Inicializar cuando el DOM esté listo
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      // Escuchar por cambios en el historial (cuando se navega entre variantes)
      window.addEventListener('popstate', () => this.handleUrlChange());

      // También observamos cambios en la URL con history.pushState/replaceState
      this.overrideHistoryMethods();
    }

    overrideHistoryMethods() {
      const self = this;
      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;

      history.pushState = function () {
        originalPushState.apply(this, arguments);
        self.handleUrlChange();
      };

      history.replaceState = function () {
        originalReplaceState.apply(this, arguments);
        self.handleUrlChange();
      };
    }

    handleUrlChange() {
      if (this.currentUrl !== window.location.href) {
        this.currentUrl = window.location.href;
        this.updateSku();
      }
    }

    updateSku() {
      fetch(window.location.href)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Buscar el elemento con el mismo ID en el nuevo HTML
          const newSkuElement = doc.getElementById(this.id);

          if (newSkuElement && this) {
            this.innerHTML = newSkuElement.innerHTML;
          }
        })
        .catch((error) => {
          console.error('Error al actualizar el SKU:', error);
        });
    }
  }

  // Definir el elemento personalizado
  if (!customElements.get('pivot-product-sku')) {
    customElements.define('pivot-product-sku', PivotProductSku);
  }
  } catch(e) { console.error(e); }
})();

})();
